export default function Logo({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="187.575 146.772 130.329 130.329"
      className={className}
    >
      <rect
        x="187.575"
        y="146.772"
        width="130.329"
        height="130.329"
        rx="31.669"
        ry="31.669"
        style={{ fill: "#4f46e5" }}
      />
      <g transform="matrix(1.034136, 0, 0, 1.034136, 67.22467, 87.910904)">
        <path
          d="M 187.753 65.231 L 185.172 68.485 C 197.515 84.418 214.122 96.612 234.992 105.065 C 233.197 107.458 231.215 110.45 229.045 114.041 C 208.699 104.167 192.092 91.151 179.225 74.993 C 168.005 89.356 151.099 102.821 128.508 115.388 C 126.937 112.395 125.029 109.44 122.785 106.523 C 146.947 95.003 164.452 81.239 175.298 65.231 L 187.753 65.231 Z M 145.114 106.299 L 210.194 106.299 C 209.746 116.547 209.26 124.551 208.736 130.311 C 208.212 136.969 206.641 141.532 204.023 144.001 C 201.331 146.544 196.693 147.778 190.109 147.703 C 185.845 147.703 181.357 147.628 176.644 147.479 C 176.196 144.636 175.597 141.495 174.849 138.054 C 181.133 138.727 185.883 139.063 189.099 139.063 C 193.064 139.063 195.795 138.427 197.291 137.156 C 198.712 135.959 199.61 133.491 199.984 129.75 C 200.433 125.411 200.769 120.362 200.993 114.602 L 153.979 114.602 L 153.979 153.875 C 153.979 160.458 157.42 163.749 164.302 163.749 L 203.125 163.749 C 211.279 163.749 215.843 161.056 216.815 155.67 C 217.787 151.257 218.61 145.833 219.283 139.4 C 221.977 140.597 224.894 141.681 228.035 142.654 C 227.138 148.639 226.053 154.249 224.781 159.485 C 222.687 168.013 216.029 172.277 204.808 172.277 L 161.721 172.277 C 150.65 172.277 145.114 166.816 145.114 155.894 L 145.114 106.299 Z"
          style={{ fill: "#ffffff" }}
        />
      </g>
    </svg>
  );
}
